import { useCallback, useEffect, useState } from "react";
import RegistrosTable from "../../components/diario-operacao/RegistrosTable";
import apiDiarioOperacao from "../../services/apis/apiDiarioOperacao";
import AdicionarRegistro from "../../components/diario-operacao/AdicionarOuEditarRegistro";
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "../../components/common/Pagination";
import ConfirmarDelete from "../../components/diario-operacao/ConfirmarDelete";


export default function DiarioOperacao() {

    const [registros, setRegistros] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [page, setPage] = useState(1);

    const [openModal, setOpenModal] = useState(false);
    const [modalState, setModalState] = useState("Adicionar");
    const [registroEdit, setRegistroEdit] = useState(null);
    const [registroDelete, setRegistroDelete] = useState(null);

    const openModalEdit = (register) => {
        setOpenModal(true);
        setModalState("Editar");
        setRegistroEdit(register);
    }

    const openModalAdd = () => {
        setOpenModal(true);
        setModalState("Adicionar");
    }

    useEffect(() => {
        (async () => {
            await findAll(page);
        })()
    }, [page]);

    const findAll = useCallback(async (page) => {
        const res = await apiDiarioOperacao.page(page);
        const data = res.data;
        setRegistros(data.items);
        setPagination(data);
    }, [page]);

    const update = useCallback(() => {
        findAll(1);
        setPage(1);
    }, [findAll, setPage]);



    const getPages = (page, totalPages) => {
        if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1);
        if (page <= 3) return [1, 2, 3, "...", totalPages];
        if (page >= totalPages - 2) return [1, "...", totalPages - 2, totalPages - 1, totalPages];
        return [1, "...", page - 1, page, page + 1, "...", totalPages];
    };

    return (
        <div className="gap-5 flex flex-col">
            <AdicionarRegistro
                openModal={openModal}
                setOpenModal={setOpenModal}
                openModalAdd={openModalAdd}
                modalState={modalState}
                registroEdit={registroEdit}
                updateList={update}
            />

            <RegistrosTable
                registros={registros}
                openModalEdit={openModalEdit}
                setItemToDelete={setRegistroDelete}
            />
            <Pagination className={"text-white"}>
                <PaginationContent>
                    <PaginationItem>
                        <PaginationPrevious
                            href="#"
                            onClick={(e) => { e.preventDefault(); setPage(page - 1); }}
                            className={page <= 1 ? "pointer-events-none opacity-50" : ""}
                        />
                    </PaginationItem>
 
                    {getPages(page, pagination?.totalPages).map((p, i) => (
                        <PaginationItem key={i}>
                            {p === "..."
                                ? <PaginationEllipsis />
                                : <PaginationLink
                                    href="#"
                                    isActive={p === page}
                                    onClick={(e) => { e.preventDefault(); setPage(p); }}
                                    className={p === page ? "opacity-50 pointer-events-none" : ""}
                                >
                                    {p}
                                </PaginationLink>
                            }
                        </PaginationItem>
                    ))}

                    <PaginationItem>
                        <PaginationNext
                            href="#"
                            onClick={(e) => { e.preventDefault(); setPage(page + 1); }}
                            className={page >= pagination?.totalPages ? "pointer-events-none opacity-50" : ""}
                        />
                    </PaginationItem>
                </PaginationContent>
            </Pagination>
            <ConfirmarDelete itemToDelete={registroDelete} setItemToDelete={setRegistroDelete} updateList={update} />

        </div>
    )
}